module.exports = __webpack_public_path__ + "img/imiwin-support.0b20503d.png";